module.exports = __webpack_public_path__ + "img/history-gas.f6dc8c6e.jpg";